// extracted by mini-css-extract-plugin
export default {"brand":"_354cwP99","navMenu":"_3m1y8O4x"};